export default __webpack_public_path__ + "static/media/mayoSmall.0fb16988.svg";